import { ROUTES as e } from "./routes.mjs";
import { matchPath as t } from "react-router-dom";
//#region src/pageDescriptions.ts
var n = [
	{
		path: e.HOME,
		key: "site:meta.home"
	},
	{
		path: e.PROPERTIES.MAP,
		key: "site:meta.map"
	},
	{
		path: e.GUIDES.ROOT,
		key: "site:meta.guides"
	},
	{
		path: e.HELP.ROOT,
		key: "site:meta.help"
	},
	{
		path: e.HELP.FAQ,
		key: "site:meta.helpFaq"
	},
	{
		path: e.EXPERIENCES.ROOT,
		key: "site:meta.experiences"
	},
	{
		path: e.SERVICES.ROOT,
		key: "site:meta.services"
	},
	{
		path: e.ABOUT,
		key: "site:meta.about"
	},
	{
		path: e.HOST_WITH_US,
		key: "site:meta.hostWithUs"
	},
	{
		path: e.LEGAL.TERMS,
		key: "site:meta.terms"
	},
	{
		path: e.LEGAL.PRIVACY,
		key: "site:meta.privacy"
	}
], r = (e) => n.find((n) => t(e, {
	path: n.path,
	exact: !0
}))?.key;
//#endregion
export { n as PAGE_DESCRIPTION_KEYS, r as descriptionKeyForPathname };
